import { encryptData, decryptData } from './cryptoUtils';

export const setWithExpiry = (key: string, value: any, ttl: number) => {
  // Automatically stringify if value is not a string
  const valueToStore = typeof value === 'string' ? value : JSON.stringify(value);
  const encryptedValue = encryptData(valueToStore);

  const item = {
    value: encryptedValue,
    expiry: new Date().getTime() + ttl,
  };
  sessionStorage.setItem(key, JSON.stringify(item));
};

export const getWithExpiry = (key: string) => {
  const itemStr = sessionStorage.getItem(key);
  if (!itemStr) return null;
  
  const item = JSON.parse(itemStr);
  if (new Date().getTime() > item.expiry) {
    sessionStorage.removeItem(key);
    return null;
  }
  // decryptData already handles JSON parsing
  return decryptData(item.value);
};

// Remove item
export const removeItem = (key: string) => {
  sessionStorage.removeItem(key);
};

// Clear all items except device selections
export const clearAllItems = () => {
  // Save device selections before clearing
  const audioDeviceId = getWithExpiry('selectedAudioDeviceId');
  const cameraDeviceId = getWithExpiry('selectedCameraDeviceId');
  
  // Get current expiry times if they exist
  let audioExpiry: number | null = null;
  let cameraExpiry: number | null = null;
  
  try {
    const audioItem = sessionStorage.getItem('selectedAudioDeviceId');
    if (audioItem) {
      const parsedItem = JSON.parse(audioItem);
      audioExpiry = parsedItem.expiry;
    }
    
    const cameraItem = sessionStorage.getItem('selectedCameraDeviceId');
    if (cameraItem) {
      const parsedItem = JSON.parse(cameraItem);
      cameraExpiry = parsedItem.expiry;
    }
  } catch (e) {
    console.error('Error parsing device selection expiry:', e);
  }
  
  // Clear everything
  sessionStorage.clear();
  
  // Restore device selections with original expiry if they existed
  if (audioDeviceId) {
    const expiry = audioExpiry || (Date.now() + 24 * 60 * 60 * 1000); // Default 24h if no expiry found
    setWithExpiry('selectedAudioDeviceId', audioDeviceId, expiry - Date.now());
  }
  
  if (cameraDeviceId) {
    const expiry = cameraExpiry || (Date.now() + 24 * 60 * 60 * 1000); // Default 24h if no expiry found
    setWithExpiry('selectedCameraDeviceId', cameraDeviceId, expiry - Date.now());
  }
};